export default __webpack_public_path__ + "static/do-support-copy-b3851814bac3c6ed0f9b02f0fdaaf4394006caf986af3639adf2a14bd4d2dbb9.png";